export default {"src":"/_next/static/media/StarBG.d6e7b928.svg","height":1110,"width":1084,"blurWidth":0,"blurHeight":0};